import React from 'react';
import { withRouter } from 'react-router-dom';
import "./auxiliary.styles.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter, faFacebookSquare } from "@fortawesome/free-brands-svg-icons"


const AuxiliaryComponent = () => (
    <div className="container-fluid top-bar">
        <div className="row">
            <div className="d-flex col-12 justify-content-end">
                <ul className="social">
                    <li>
                        <a
                            href="https://twitter.com/USONV"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Visit our Twitter page (opens in new tab)"
                        >
                            <FontAwesomeIcon icon={faTwitter} size="lg" />
                        </a>

                    </li>
                    <li>
                        <a
                            href="https://www.facebook.com/USONV"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Visit our Facebook page (opens in new tab)"
                        >
                            <FontAwesomeIcon icon={faFacebookSquare} size="lg" aria-hidden="true" />
                        </a>
                    </li>
                </ul>
                <span className="auxiliary-text-patient-portal">
                    <a href="https://epicpnwmychart.optum.com/mychart/Authentication/Login" rel="noreferrer" target="_blank" aria-label="Access patient portal (opens in new tab)">PATIENT PORTAL</a>
                </span>
            </div>
        </div>
    </div>



)

export default withRouter(AuxiliaryComponent);
